// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"7648e628","124":"e25b4324","298":"44a1bd1e","732":"f1f9d938","734":"28334293"}[chunkId] + ".chunk.css";
};